<div class="container-box">
  <div class="account-part user-management">
    <div class="box-title">
      {{'assignmentManagement.teacher.assignedTeachers.title' | translate}}
      <button class="submit-button change-password-btn" (click)="openInviteDialog()">
        {{'assignmentManagement.teacher.assignedTeachers.inviteLabel' | translate}}
      </button>
    </div>
    <mat-form-field class="search-field w-100">
      <input type="text" [placeholder]="'system.form.placeholder.search' | translate" name="searchField" matInput
             [formControl]="searchField" (ngModelChange)="search()">
      <button mat-button class="clear" *ngIf="searchField.value" matSuffix mat-icon-button aria-label="Clear"
              (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <div #scrollContent class="account-list">
      <table *ngIf="list.length" mat-table [dataSource]="list"
             [ngClass]="{'mat-elevation-z8': true, 'loading': showSpinner}">
        <ng-container matColumnDef="title">
          <mat-cell *matCellDef="let element">{{element.title}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-cell *matCellDef="let element; let i = index;">
            <mat-icon class="trash" (click)="removeTeacher(i)">delete</mat-icon>
          </mat-cell>
        </ng-container>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </table>
      <div *ngIf="!showSpinner && !list.length" class="empty-list">
        {{'assignmentManagement.noAssignments' | translate}}
      </div>
      <app-spinner *ngIf="showSpinner" class="full"></app-spinner>
    </div>
  </div>
</div>
